// Elements/SidebarViewModal.jsx

import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

function SidebarViewModal({ sidebarIconsOnlyCurrent, savePrefrenceCallback, setHomeData }) {
  const { register, setValue, watch } = useFormContext();

  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (sidebarIconsOnlyCurrent) {
      setSelected(2); // Page Names on Hover Only
      setValue("SidebarView", true);
    } else {
      setSelected(1); // Icons and Page Names
      setValue("SidebarView", false);
    }
  }, [sidebarIconsOnlyCurrent, setValue]);

  const handleSelected = (option) => {
    setSelected(option);
    const iconsOnly = option === 2;
    setValue("SidebarView", iconsOnly);

    setTimeout(() => {
      const updated = { ...watch(), SidebarView: iconsOnly };
      savePrefrenceCallback(updated);
      setHomeData(updated);
    }, 0);
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-evenly" style={{ gap: "0px" }}>
        <div
          className={"d-flex align-items-center gap-1 height-35  "}
          onClick={() => handleSelected(1)}
        >
          <input
            type="radio"
            {...register("SidebarView")}
            className="radio-input"
            checked={selected === 1}
            readOnly
          />
          <div className={`radio-circle ${selected === 1 ? "checked" : ""}`} />
          <span>Icons and Page Names</span>
        </div>

        <div
          className={"d-flex align-items-center gap-1 height-35 "}
          onClick={() => handleSelected(2)}
        >
          <input type="radio" className="radio-input" checked={selected === 2} readOnly />
          <div className={`radio-circle ${selected === 2 ? "checked" : ""}`} />
          <span>Page Names Shown on Hover Only</span>
        </div>
      </div>
    </>
  );
}

export default SidebarViewModal;
